import LandingPage from '../templates/LandingPage';
import searchIcon from '../../assets/svg/search.svg'

import place1 from '../../assets/images/place1.png'
import place2 from '../../assets/images/place2.png'
import place3 from '../../assets/images/place3.png'
import place4 from '../../assets/images/place4.png'
import place5 from '../../assets/images/place5.png'

import Faq from '../components/card/Faq';
import { useState } from 'react';

function About() {

  const [searchMode, setSearchMode] = useState(false)
  const [search, setSearch] = useState("")

  const abks = [
    {image: place1, name: "Marvin McKinney", position: "Person’s position here"},
    {image: place2, name: "Darlene Robertson", position: "Person’s position here"},
    {image: place3, name: "Robert Fox", position: "Person’s position here"},
    {image: place4, name: "Darlene Robertson", position: "Person’s position here"},
    {image: place5, name: "Robert Fox", position: "Person’s position here"},
  ]
  
  return (
    <LandingPage>
      <div className="px-8 lg:px-16 py-18 flex flex-col items-center section-one">
        <div className="flex w-full lg:w-2/3 mt-32 justify-between">
          <p className="text-yellow text-xl lg:text-3xl font-bold">
            "The only thing dear to our heart is to bring you closer to your money and friends."
          </p>
          {/* <div className={`flex opacity-50 text-white items-start ${searchMode ? "border-b-2" : ""} `}>
            <img src={searchIcon} alt="o" className="self-start mt-2 cursor-pointer" width="30px" onClick={ () => setSearchMode(true)} />
            <div className={`mt-3 flex items-center ml-4 ${searchMode ? "" : "hidden"}`}>
              <input type="text" className="bg-transparent focus:outline-none" focus value={search} onChange={ e => setSearch( e.target.value )}/>
              <div className="text-white bg-brown ml-3 bg-opacity-25 w-6 h-6 rounded-full cursor-pointer flex justify-center items-center" onClick={ () => { setSearch(""); setSearchMode(false) }}>&times;</div>
            </div>
            <span className={`text-xl lg:text-3xl place-self-start ml-4 cursor-pointer ${searchMode ? "hidden" : ""}`} onClick={ () => setSearchMode(true)}>Search</span>
          </div> */}
        </div>
        <div className="flex flex-col w-full lg:w-2/3 mb-5">
          <div className="py-8 px-10 rounded-lg my-4 text-white bg-brown bg-opacity-25">
            <div className="relative">
              <h2 className="font-bold">Why BitcoinAboki? Nothing! Yes… Nothing!</h2>
              <div className={`mt-4 break-normal text-sm transition duration-500 ease-in-out  overflow-hidden `}>
              Okay… I get. You dey expect big grammar abi? He shock you! We just wan help people wey dey use bitcoin enjoy life with their friends. Dasall! Na why our slogan na: Beyond Rates. Even though we give the best rates in the market, BitcoinAboki pass that level. BitcoinAboki na your surest padi for bitcoin exchange.  
              </div>
            </div>
        </div>
        </div>

        <div className="flex flex-col w-full lg:w-2/3 justify-between">
          <p className="text-yellow text-xl lg:text-2xl font-bold">
            Meet the Abokis
          </p>
          <div className="flex opacity-50 text-white items-start text-xs">
            Happy and friendly digital disruptors making life easier by developing solutions in the cryptocurrency space.
          </div>
        </div>

        <div className="flex flex-col w-full lg:w-2/3 mb-12">
          <div className="py-8 px-10 rounded-lg my-4 text-white bg-brown bg-opacity-25">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              {
                abks.map( abk => (
                  <div class="">
                    <img src={abk.image} alt="1" width="100%"/>
                    <br/>
                    <h3>{ abk.name }</h3>
                    <small>{ abk.position }</small>
                  </div>
                ))
              }
            </div>
          </div>
        </div>

      </div>
    </LandingPage>
  );
}

export default About;
